"use client"

import { ArrowDownRight } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `ArrowDownRightIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const ArrowDownRightIcon = component(Icon)({ as: ArrowDownRight })
